/**
 * Default (LMI) ContinuityCoach theme tokens.
 * Used as documentation of the baseline; CSS still owns most LMI styles.
 */
export default {
  id: 'default',
  displayName: 'ContinuityCoach',
  fonts: {
    family: 'Roboto, "Helvetica Neue", Arial, sans-serif',
  },
  colors: {
    brandPrimary: '#f1c400',
    brandPrimaryHover: '#ffd514',
    brandPrimaryActive: '#d8b100',
    brandSecondary: '#343579',
    brandNavy: '#14255e',
    brandOnPrimary: '#14255e',
    brandAccent: '#00685e',

    surface: '#ffffff',
    surfaceMuted: '#f1f2f4',
    appBg: '#f4f5f7',

    textStrong: '#111827',
    textBody: '#344054',
    textMuted: '#667085',

    borderSoft: '#e4e7ec',
  },
};
